import { useQuery } from '@tanstack/react-query';
import { getDailyClip, getStreak } from '../services/daily.service';

// The referee's daily clip for the Home hero. Gated by `enabled` like the other referee-scoped
// queries (only clip-answering roles have a daily clip; super_admin would 403). 30s stale window
// keeps it instant on revisit and quietly fresh after an answer flips `answered`.
export function useDailyClipQuery(enabled: boolean) {
  return useQuery({
    queryKey: ['daily-clip'],
    queryFn: getDailyClip,
    enabled,
    staleTime: 30_000,
  });
}

// The referee's streak summary for the Home streak card. Same gating + stale window.
export function useStreakQuery(enabled: boolean) {
  return useQuery({
    queryKey: ['streak'],
    queryFn: getStreak,
    enabled,
    staleTime: 30_000,
  });
}
